import { ClockIcon } from 'assets/icons';

// What comes next for a company (« Rappel 14:30 », « Relancer en janv. »),
// behind a clock, in the orange of the prototype's « Action à faire ».
const CompanyAction = ({ children }) => (
  <span className="flex min-w-0 max-w-[190px] items-center gap-2 font-medium text-yellow-800">
    <span className="flex shrink-0 text-gray-900">
      <ClockIcon wh={18} color="currentColor" />
    </span>
    <span className="truncate">{children}</span>
  </span>
);

export default CompanyAction;
